<template>
  <b-container flex>
    <div style="padding-top: 20px; padding-bottom: 10px"><span
        style="font-weight: bold; font-size: large; padding-top: 20px; padding-bottom: 10px">Waste Diversion</span>
    </div>
    <div style="padding-top: 20px; padding-bottom: 10px">
    <span style="color: darkgreen; font-style: italic">
    *Goal is >75% diversion excluding pomace, as pomace artificially inflates the diversion tonnage
  </span>
    </div>
    <b-row style="padding-top: 5px ">
      <b-col sm="6">Trash (Tons):</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3" align-h="end">
        <b-form-input @change="sendUpdate" v-model.number="trash" min="0" max="1000" step=".1"
                      :lazy-formatter=true
                      :formatter="roundColumnValue"
                      type=number :readonly="isViewer"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="6">Recycling (Tons):</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3">
        <b-form-input @change="sendUpdate" v-model.number="recycling" min="0" max="1000" step=".1"
                      :lazy-formatter=true
                      :formatter="roundColumnValue"
                      type="number" :readonly="isViewer"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="6">Compost (Tons):</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3">
        <b-form-input @change="sendUpdate" v-model.number="compost" min="0" max="1000" step=".1"
                      :lazy-formatter=true
                      :formatter="roundColumnValue"
                      :readonly="isViewer"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="6">Pomace (Tons):</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3">
        <b-form-input @change="sendUpdate" v-model.number="pomace" min="0" max="1000" step=".1"
                      :lazy-formatter=true
                      :formatter="roundColumnValue"
                      type="number" :readonly="isViewer"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="6">Diversion %:</b-col>
      <b-col sm="3"></b-col>
      <b-col sm="3">
        <b-form-input v-model.number="diversion"
                      type="number" :readonly="true"></b-form-input>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import {roundColumnValueToOneDecimalPlace} from "@/MetricUtils";

export default {
  name: "WasteDiversion",
  props: {year: Number, groupId: String},

  data() {
    return {
      myYear: this.year,
      metricId: this.id,
      myGroupId: this.groupId,
      trash: 0,
      recycling: 0,
      compost: 0,
      pomace: 0,
      createdAt: null,
      updatedAt: null,
      id: null,
      enteredValueDecimalPlaces: 2,
      totalsValueDecimalPlaces: 0,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
    }
  },
  mounted() {
    console.log("Waste Diversion")
    this.loadWaterDiversion();
  },
  watch: {
    year: function (newVal, oldVal) {
      this.metricYearVal = newVal;
    },
    id: function (newVal, oldVal) {
      this.metricId = newVal;
    },
    groupId: function (newVal, oldVal) {
      this.myGroupId = newVal;
    }
  },
  computed: {
    diversion: function () {
      let divertableWaste = this.compost + this.recycling;
      let totalWaste = this.trash + divertableWaste;
      if (totalWaste === 0) {
        return 0;
      }
      let wasteDiversion = Math.round((divertableWaste / totalWaste) * 100);
      console.log(`Divertable Waste: ${divertableWaste}, Total Waste: ${totalWaste}, Calculated Waste Diversion: ${wasteDiversion}`);
      return wasteDiversion;
    }
  },
  methods: {
    roundColumnValue: function (value) {
      return roundColumnValueToOneDecimalPlace(value);
    },
    loadWaterDiversion: function () {
      this.$http.get(`metrics/waste/${this.myGroupId}/${this.myYear}`)
          .then(result => {
            let commentObject = result.data;
            if (commentObject) {
              this.trash = commentObject.trash;
              this.recycling = commentObject.recycling;
              this.compost = commentObject.compost;
              this.pomace = commentObject.pomace;
              this.year = commentObject.year;
              this.groupId = commentObject.groupId;
              this.id = commentObject._id;
            }
          })
          .catch(error => {
            console.log(`Couldn't Retrieve Comments for groupId ${this.myGroupId}, year: ${this.myYear}, metric type: ${this.myMetricType}  with error`, error.message);
          })
    },
    sendUpdate: function () {
      let self = this;
      let wasteDiversionMetric = {
        trash: this.trash,
        recycling: this.recycling,
        compost: this.compost,
        pomace: this.pomace,
        year: this.year,
        groupId: self.groupId,
        _id: this.id
      };

      let theMethod = !this.id ? 'post' : 'put';
      let url = !this.id ? `metrics/waste/${self.groupId}` : `metrics/waste/${this.id}`;
      this.createdAt = this.createdAt !== null ? this.createdAt : Date.now();
      this.updatedAt = this.updatedAt !== null ? this.updatedAt : Date.now();

      this.$http.request(
          {
            method: theMethod,
            url: url,
            data: wasteDiversionMetric,
            headers: {
              'content-type': 'application/json'
            }

          })
          .then(result => {
            if (theMethod === 'post') {
              self.id = result.data._id;
              self.updatedAt = result.data.updatedAt;
            }
            console.log(`Updated; ${self.updatedAt}`)
          })
          .catch(error => {
            let action = theMethod === 'post' ? 'create' : 'update';
            console.log(`Couldn't ${action} Comments for groupId ${this.myGroupId}, year: ${this.myYear}, metric type: ${this.myMetricType}  with error`, error.message);
          })
    }
  }
}
</script>

<style scoped>

</style>
